import { calculateAspectRatio } from "@msuite/utils/files";
import { guardString } from "@msuite/utils/strings";
import { Icon } from "../icons";
import { useLightbox } from "./context";
import type { ItemProps } from "./shared";

export function LightboxImage({ width, height, src, fileName, hasAnnotations }: ItemProps) {
	/** Context */
	const lightbox = useLightbox();

	const aspectRatio = calculateAspectRatio(width, height);

	/** Render */
	return (
		<div
			className="relative"
			style={{
				height: lightbox.itemHeight,
				aspectRatio,
			}}
		>
			<img
				src={guardString(src)}
				className="object-cover w-full h-full"
				alt={fileName}
			/>
			{hasAnnotations && (
				<div className="absolute top-1 left-1 flex-center rounded-full bg-black/60 p-1 text-white">
					<Icon
						name="VectorSquare"
						size={12}
					/>
				</div>
			)}
		</div>
	);
}
